"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("./isNil"));

var passThrough = function passThrough(value) {
  return value;
};
/**
 * Iterates over a Map and returns a plain old javascript object with the same key/value pairs.
 * @param {Map} inMap
 * @param {function} mappingFunction
 * @returns {Object}
 */


var convertMapToObject = function convertMapToObject(inMap) {
  var mappingFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : passThrough;
  // TODO is this the correct behavior here?
  if ((0, _isNil["default"])(inMap)) return null;

  if (!(inMap instanceof Map)) {
    throw new Error('Can only convert Map to object');
  }

  var result = {};
  inMap.forEach(function (value, key) {
    result[key] = mappingFunction(value);
  });
  return result;
};

var _default = convertMapToObject;
exports["default"] = _default;